import baseUrl from "./../../util/backend";
import axios from "axios";

let timer;
const expireTimer = 3600 * 1000;
export default {
  state() {
    return {
      userId: null,
      name: null,
      profilePic: null,
      permission: null,
      token: null,
      roleId: null,
      detailId: null,
    };
  },
  mutations: {
    setUser(state, payload) {
      state.userId = payload;
    },
    setName(state, payload) {
      state.name = payload;
    },
    setPermission(state, payload) {
      state.permission = payload;
    },
    setToken(state, payload) {
      state.token = payload;
    },
    setProfilePic(state, payload) {
      state.profilePic = payload;
    },
    setRoleId(state, payload) {
      state.roleId = payload;
    },
    setDetailId(state, payload) {
      state.detailId = payload;
    },
  },
  actions: {
    setExpire(context) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        context.dispatch("logout");
      }, expireTimer);
    },
    changeName(context, payload) {
      context.commit("setName", payload);
    },
    changePic(context, payload) {
      context.commit("setProfilePic", payload);
    },
    async login(context, payload) {
      const res = await axios.post(`${baseUrl}/login`, payload);
      // console.log(res.data.data);
      if (res.data.status !== "success") {
        // const error = new Error(res.data.message || "Failed to authenticate.");
        const error = new Error("Failed to authenticate.");
        throw error;
      }
      const userData = res.data.data;
      context.commit("setUser", userData.user_id);
      context.commit("setName", userData.name);
      context.commit("setPermission", userData.role);
      context.commit("setToken", userData.token);
      context.commit("setProfilePic", userData.img_profile);
      context.commit("setRoleId", userData.role ? userData.role.role_id : null);
      context.commit("setDetailId", res.data.detail_id);
      if (userData.token) {
        localStorage.setItem("token", userData.token);
      }
      timer = setTimeout(() => {
        context.dispatch("logout");
      }, expireTimer);
    },
    async tryLogin({ commit, dispatch }) {
      console.log("tryLogin");
      const lastToken = localStorage.getItem("token");
      const res = await axios.post(`${baseUrl}/login`, {
        token: lastToken,
      });
      if (res.data.status !== "success") {
        dispatch("logout");
        // const error = new Error(res.data.message || "Failed to authenticate.");
        const error = new Error("Please login again.");
        throw error;
      }

      timer = setTimeout(() => {
        dispatch("logout");
      }, expireTimer);

      const userData = res.data.data;
      commit("setUser", userData.user_id);
      commit("setName", userData.name);
      commit("setPermission", userData.role);
      commit("setToken", userData.token);
      commit("setProfilePic", userData.img_profile);
      commit("setRoleId", userData.role ? userData.role.role_id : null);
      commit("setDetailId", res.data.detail_id);
      localStorage.setItem("token", userData.token);
    },
    logout(context) {
      localStorage.removeItem("token");
      localStorage.removeItem("LS_ROUTE_KEY");
      context.commit("setUser", null);
      context.commit("setName", null);
      context.commit("setPermission", null);
      context.commit("setToken", null);
      clearTimeout(timer);
    },
  },
  getters: {
    isAuthenticated(state) {
      return state.userId;
    },
    getUserId(state) {
      return state.userId;
    },
    getName(state) {
      return state.name;
    },
    getPermission(state) {
      return state.permission;
    },
    getToken(state) {
      return state.token;
    },
    getProfilePic(state) {
      return state.profilePic;
    },
    getRoleId(state) {
      return state.roleId;
    },
    getDetailId(state) {
      return state.detailId;
    },
  },
};
